import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';
import CartActions from '~redux/Cart/actions';
import { slugify } from '~utils/string';
import NextUpActions from '~redux/NextUp/actions';

export const useProductDetail = (basePath, product, category) => {
  const dispatch = useDispatch();
  const futureOrderModalIsOpen = useSelector((state) => state.modal[`${MODALS.FUTURE_ORDER}ModalIsOpen`]);
  const address = useSelector((state) => state.auth.address?.current?.textAddress);
  const enabledForceEnterAddress = useSelector((state) => state.core.settings.enabledForceEnterAddress);

  const showOpenAddressModal = enabledForceEnterAddress && !address;

  const history = useHistory();
  return () => {
    if (futureOrderModalIsOpen) {
      return;
    }

    if (product) {
      const { id, name } = product.product ? product.product : product;
      const nameWithDashes = slugify(name);
      const categoryWithDashes = slugify(category);
      const productUrlPath = `${basePath}/product/${categoryWithDashes}/${nameWithDashes}-${id}`;

      if (showOpenAddressModal) {
        dispatch(ModalActions.openModal(MODALS.DELIVERY_OR_PICKUP));
        const openProductDetailModalAction = ModalActions.openModalWithData(MODALS.PRODUCT_DETAIL, {
          open: true,
          productId: id,
          productUrlPath
        });
        dispatch(NextUpActions.clearAllActionsByTarget(openProductDetailModalAction.target));
        dispatch(NextUpActions.setNextAction(openProductDetailModalAction));
        return;
      }

      history.replace(productUrlPath);
    }

    dispatch(ModalActions.openModal(MODALS.PRODUCT_DETAIL));
  };
};

export const useModifyProduct = (basePath, product) => {
  const productDetail = useProductDetail(basePath, product, product.category);
  const dispatch = useDispatch();
  return () => {
    productDetail();
    dispatch(CartActions.setItem(product));
  };
};
